import { Button, Grid, MenuItem, TextField } from '@mui/material'
import { memo, useContext } from 'react'
import { GlobalContext } from '../../../App'
import { metodoPrograma } from '../../../components/api'
import { z } from 'zod'
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

const retornaLocalAtendimento = (u = [], idLocalAtendimento) => ({
  idLocalAtendimento,
  idFormaPagamento: u?.[0] || undefined,
  dsFormaPagamento: u?.[1] || '',
  snAceitaParcelamento: u?.[2] || 'N',
})

const createFormaPagamento = z.object({
  idFormaPagamento: z.number().optional(),
  idLocalAtendimento: z.number(),
  dsFormaPagamento: z.string().min(3, {
    message: 'Nome da forma de pagamento inválido',
  }),
  snAceitaParcelamento: z.string(),
})

const Edicao = ({ dados, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createFormaPagamento),
    defaultValues: retornaLocalAtendimento(dados, localAtendimento[0]),
  })

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }
  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <TextField
            {...register('dsFormaPagamento')}
            label="Nome da Forma de Pagamento"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.dsFormaPagamento}
            helperText={errors.dsFormaPagamento?.message}
          />
        </Grid>
        <Grid item xs={3}>
          <Controller
            name="snAceitaParcelamento"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Aceita Parcelamento"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                select
                error={!!errors.snAceitaParcelamento}
                helperText={errors.snAceitaParcelamento?.message}
              >
                <MenuItem value="S">Sim</MenuItem>
                <MenuItem value="N">Não</MenuItem>
              </TextField>
            )}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao)
